module.exports = __webpack_public_path__ + "static/img/10005 (6).4cf860f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10005 (6).webp
// module id = qdTO
// module chunks = 14